// extracted by mini-css-extract-plugin
module.exports = {"skeletonGrid":"SkeletonGrid_skeletonGrid__3E-cV"};